export const restoreNotificationsBulkActionType = 'restoreNotifications';
